import { render, staticRenderFns } from "./pageGzhMenu.vue?vue&type=template&id=236fc90c&scoped=true"
import script from "./pageGzhMenu.vue?vue&type=script&lang=js"
export * from "./pageGzhMenu.vue?vue&type=script&lang=js"
import style0 from "./pageGzhMenu.vue?vue&type=style&index=0&id=236fc90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fc90c",
  null
  
)

export default component.exports